/** @format */
import { smallTablet } from '@mpb-com/feather/helpers/media-queries';
import { css } from 'styled-components';

import { cssRepeat } from '@toucan/helpers/styles';

/**
 * Base styles for the Footer component
 */
const baseStyles = () => css`
    background: var(--colors-surface-secondary);
    border-top: 0.1rem solid var(--colors-border-light);
    padding-top: var(--layout-spacing-48);
    padding-bottom: var(--layout-spacing-24);
    grid-row-gap: var(--layout-spacing-48);

    &.footer--mobile {
        background: var(--colors-surface-primary);
    }

    .top-row {
        display: grid;
        grid-template-columns: minmax(16rem, 1fr) minmax(max-content, 2fr) minmax(
                auto,
                32rem
            );
        grid-template-areas: 'footer-logo footer-links footer-credit-message';
        grid-column-gap: var(--layout-spacing-32);
    }

    .bottom-row {
        display: grid;
        grid-template-columns: ${cssRepeat(3, 'max-content')};
        grid-template-areas: 'footer-market-selector footer-payment-methods footer-copyright-notice';
        grid-column-gap: var(--layout-spacing-24);
        margin-top: var(--layout-spacing-48);
    }

    .logo {
        grid-area: footer-logo;
    }

    .links {
        display: grid;
        grid-area: footer-links;
        grid-template-columns: 1fr 1fr 1fr;
        grid-column-gap: var(--layout-spacing-24);
    }

    .credit-message {
        grid-area: footer-credit-message;
    }

    .market-selector {
        grid-area: footer-market-selector;
    }

    .payment-methods {
        grid-area: footer-payment-methods;
        align-self: center;
    }

    .copyright-notice {
        grid-area: footer-copyright-notice;
        align-self: center;
        justify-self: end;
    }

    ${smallTablet(css`
        .top-row {
            grid-template-columns: 1fr;
            grid-template-areas:
                'footer-links'
                'footer-logo'
                'footer-credit-message';
            grid-column-gap: var(--layout-spacing-32);
            grid-row-gap: var(--layout-spacing-32);

            .logos {
                display: flex;
                justify-content: center;
            }
        }

        .links {
            display: block;
        }

        .links ul {
            column-count: 2;
            grid-column-gap: var(--layout-spacing-24);
        }

        .credit-message {
            margin-bottom: var(--layout-spacing-32);
            text-align: center;
        }

        .bottom-row {
            margin-top: 0;
            grid-row-gap: var(--layout-spacing-32);
            grid-template-rows: 1fr 1fr;
            grid-template-columns: 1fr 1fr;
            grid-template-areas:
                'footer-payment-methods footer-payment-methods'
                'footer-market-selector footer-copyright-notice';
        }

        .payment-methods {
            justify-self: center;
        }
    `)}
`;

/**
 * The Footer component styles
 *
 * @param {FooterProps} props The footer properties object
 */
export const styles = () => css`
    ${baseStyles()}
`;
